import { useEffect } from "react";
import { createContext, useContext, useState } from "react";
import { EventosTabs } from "./EventosTabs";
import { useTab } from "../../store/useTab";

interface TabProps {
  currentTab: string;
  setCurrentTab: (tab: string) => void;
}
const TabContext = createContext({} as TabProps);

export function Eventos() {
  const setTab = useTab((store) => store.setTab);
  const [currentTab, setCurrentTab] = useState<string>("tab1");

  useEffect(() => {
    setTab("Eventos");
  }, [setTab]);

  return (
    <TabContext.Provider value={{ currentTab, setCurrentTab }}>
      <header className="mb-2 border-b border-zinc-200/80 pb-6 dark:border-zinc-800">
        <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-white sm:text-3xl">
          Eventos
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-zinc-600 dark:text-zinc-400">
          Gerencie eventos, cadastros e certificados em lote.
        </p>
      </header>
      <EventosTabs />
    </TabContext.Provider>
  );
}

export const useTabContext = () => useContext(TabContext);
